import store from '../store/Store';
import { UserOnboardingState } from '../store/schema/BookWithMeOrganizerStore';

export function isDefaultServiceOnboardedUser(): boolean {
    const defaulServiceOnboardedUserStates = [
        UserOnboardingState.UserFirstSessionDefaulServiceCreated,
        UserOnboardingState.UserDefaultServiceOnboarded,
    ];
    return defaulServiceOnboardedUserStates.includes(store.userOnboardingState);
}

export function isFirstSessionUser(): boolean {
    const firstSessionUserStates = [
        UserOnboardingState.UserFirstSesionPostFRE,
        UserOnboardingState.UserFirstSessionDefaulServiceCreated,
    ];
    return firstSessionUserStates.includes(store.userOnboardingState);
}
